<div class="mydocma-mm-task-dashboard">
  <mydocma-task-dashboard (closeClick)="onCloseClick()"></mydocma-task-dashboard>
</div>
